"use client";

import { c as _c } from "react/compiler-runtime";
import { createDeferredPromise } from "@opensea/utils";
import { useAuthenticateFlow } from "@opensea/wallet";
import { useConnectFlow } from "@/hooks/use-connect-flow";
import { useAddress, useAuthenticated } from "@/hooks/wallet";
export function useAuthenticatedCallback(callback, t0) {
  const $ = _c(10);
  let t1;
  if ($[0] !== t0) {
    t1 = t0 === undefined ? {} : t0;
    $[0] = t0;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const options = t1;
  const address = useAddress();
  const authenticated = useAuthenticated();
  const t2 = options.source ?? "Authenticated Callback";
  let t3;
  if ($[2] !== t2) {
    t3 = {
      source: t2
    };
    $[2] = t2;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  const connectFlow = useConnectFlow(t3);
  const authenticateFlow = useAuthenticateFlow();
  let t4;
  if ($[4] !== address || $[5] !== authenticateFlow || $[6] !== authenticated || $[7] !== callback || $[8] !== connectFlow) {
    t4 = async (...t5) => {
      const args = t5;
      if (address && authenticated) {
        return await callback(...args);
      }
      const deferredPromise = createDeferredPromise();
      const onAuthenticated = async () => {
        ;
        try {
          const result = await callback(...args);
          deferredPromise.resolve(result);
        } catch (t6) {
          const error = t6;
          deferredPromise.reject(error);
        }
      };
      if (address) {
        authenticateFlow({
          autoPromptSiwe: true,
          onAuthenticated
        });
      } else {
        connectFlow({
          onAuthenticated
        });
      }
      return deferredPromise.promise;
    };
    $[4] = address;
    $[5] = authenticateFlow;
    $[6] = authenticated;
    $[7] = callback;
    $[8] = connectFlow;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  const fn = t4;
  return fn;
}